import {
    d as m
} from "./utils-BUfVYLTt.js";
class v extends HTMLElement {
    constructor() {
        super(), this.sectionId = this.getAttribute("data-section-id"), this.input = this.querySelector('[js-predictive-search="input"]'), this.clearSearch = this.querySelector('[js-predictive-search="clear"]'), this.handleSearch = m(this.handleSearch.bind(this), 300)
    }
    connectedCallback() {
        this.setEventListeners()
    }
    setEventListeners() {
        var e;
        this.input.addEventListener("keyup", this.handleSearch), (e = this.clearSearch) == null || e.addEventListener("click", this.handleClearSearch.bind(this))
    }
    async handleSearch(e) {
        var s, i, c, a, h, n, d;
        try {
            const t = e.target,
                r = new FormData(t.closest("form")).get("q").toString().trim() || "";
            if (r.length > 0 ? (s = this.clearSearch) == null || s.classList.remove("is-hidden") : (i = this.clearSearch) == null || i.classList.add("is-hidden"), !r) {
                (c = this.querySelector('[js-predictive-search="results"]')) == null || c.classList.add("is-hidden"), (a = this.querySelector('[js-predictive-search="empty"]')) == null || a.classList.remove("is-hidden");
                return
            }
            const resourcesOptionsFields = encodeURIComponent('resources[options][fields]');

            const l = new URLSearchParams({
                q: r,
                sections: this.sectionId,
                'resources[options][fields]': 'title,product_type,variants.title,vendor,variants.sku'
            }),
                u = await fetch(`${window.Shopify.routes.root}search/suggest?${l.toString()}`).then(S => S.json()),
                p = (h = new DOMParser().parseFromString(u[this.sectionId], "text/html").querySelector('[js-predictive-search="results"]')) == null ? void 0 : h.innerHTML,
                o = this.querySelector('[js-predictive-search="results"]');
            if (!o) return;
            o.innerHTML = p || "", (n = this.querySelector('[js-predictive-search="results"]')) == null || n.classList.remove("is-hidden"), (d = this.querySelector('[js-predictive-search="empty"]')) == null || d.classList.add("is-hidden")
        } catch (t) {
            console.error("Error in predictive search:", t)
        }
    }
    handleClearSearch() {
        var e, s;
        this.input.value = "", this.clearSearch.classList.add("is-hidden"), (e = this.querySelector('[js-predictive-search="results"]')) == null || e.classList.add("is-hidden"), (s = this.querySelector('[js-predictive-search="empty"]')) == null || s.classList.remove("is-hidden")
    }
}
customElements.define("uwp-predictive-search", v);